import React from 'react'
import { Container,Row,Col,Button } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

function CustomHeader({downloadData,downloadFunction,isActive,title,subtitle,addData,status}) {
  const navigate=useNavigate()
    const { list: settings } = useSelector((state) => state.settings);

  return (
    <Row className="mb-4 align-items-center">
        <Col md={6}>
          <h4 className="fw-bold">{title}</h4>
          <small className="text-muted">
{subtitle}
          </small>
        </Col>
        <Col className="text-start"md={6}>
          {addData&&
          <Button variant="success" className='mx-2'
  onClick={() =>{

    if(status=="meal"){
    if(isActive){
alert(`عذراً، التعديل متاح فقط من ${settings?.next_cycle_end} إلى ${settings?.next_cycle_start}`);         
    }else{
          navigate(`/dashboard/add-${status}`)}

    }else{
                navigate(`/dashboard/add-${status}`)

    }
  }
  }
          >أضافة</Button>
        }
        {downloadData&&
          <Button variant="success"onClick={downloadFunction}>حمل البيانات</Button>
        }
      
        </Col>
      </Row>

  )
}

export default CustomHeader